import { render, staticRenderFns } from "./Page400.vue?vue&type=template&id=6ba4d49e"
import script from "./Page400.vue?vue&type=script&lang=js"
export * from "./Page400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports